import React from 'react';
import PropTypes from 'prop-types';

// Form Template
import FormTemplate from '../common/Components/FormTemplate';
import AdhocProgram from './AdhocProgram';
import AddEmployeeToProgram from './AddEmployeeToProgram';
import ConfirmAdhocProgramCreation from './ConfirmAdhocProgramCreation';
import {
  adhocProgramFormStates,
  currentFlowTypeEnum,
  programStatusEnum,
} from '../../../../common/components/constants';
import {
  GC_PLAN_SUBTITLE_STEP_1,
  GC_PLAN_SUBTITLE_STEP_2,
  GC_PLAN_SUBTITLE_STEP_3,
} from '../common/Components/constants';

function AdhocProgramForm({ flowType, planData, planDataFlag, toStep }) {
  return (
    <FormTemplate toStep={toStep}>
      <AdhocProgram
        flowType={flowType}
        step={1}
        planData={planData}
        planDataFlag={planDataFlag}
        subTitle={GC_PLAN_SUBTITLE_STEP_1}
      />
      <AddEmployeeToProgram step={2} subTitle={GC_PLAN_SUBTITLE_STEP_2} />
      <ConfirmAdhocProgramCreation
        step={3}
        planData={planData}
        planDataFlag={planDataFlag}
        subTitle={GC_PLAN_SUBTITLE_STEP_3}
      />
    </FormTemplate>
  );
}

AdhocProgramForm.propTypes = {
  planData: PropTypes.oneOf(adhocProgramFormStates),
  planDataFlag: PropTypes.bool,
  flowType: PropTypes.oneOf(currentFlowTypeEnum),
  toStep: PropTypes.number,
};

AdhocProgramForm.defaultProps = {
  planData: {},
  planDataFlag: programStatusEnum.DRAFTED,
  flowType: currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD,
  toStep: 1,
};

export default AdhocProgramForm;
